module.exports = __webpack_public_path__ + "static/media/icon-question.4667b983.svg";